import React from "react";
import "./Loading.css";

function Loading() {
  return (
    <div className="loading-container">
      <div class="loading">
        <div class="arc"></div>
        <div class="arc"></div>
        <div class="arc"></div>
      </div>
    </div>
  );
}

export default Loading;
